<div class="view-container">
  <mat-card class="order-medicine-create-view">
    <div class="mbp-page-header order-medicine-create__header">
      <div class="mbp-page-header__icon">
        <mat-icon>add_circle</mat-icon>
      </div>
      <div>
        <h1 class="mbp-page-header__title">Add medicine</h1>
        <p class="order-medicine-create__subtitle">Add medicine to the customer order system.</p>
      </div>
    </div>

    <div class="add-medicine-container">
      <core-add-order-medicine (onMedicineAdd)="addOrderItem($event)"></core-add-order-medicine>
    </div>

    <div class="order-medicine-create__actions">
      <a mat-stroked-button class="order-medicine-create__back-btn" routerLink="/portal/order-medicine">
        <mat-icon>arrow_back</mat-icon> Back to list
      </a>
    </div>
  </mat-card>
</div>
